import React from 'react';
import type {ComponentPropsWithoutRef} from 'react';


type NativeProps = ComponentPropsWithoutRef<'div'>;

export type DialogHoleProps = NativeProps;

export const DialogHole = ({
    className,
    ...restProps
}: DialogHoleProps) => {
    return (
        <div
            {...restProps}
            className={`pdx-l pdy-m ${className ?? ''}`}>
            {restProps.children}
        </div>
    );
};
